/**
 * @generated SignedSource<<dd9c517ea9887d3fa6359f8111676e06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserAccountLocationSource = "AUTO_DETECTED_ON_SIGNUP" | "MANUALLY_SET_BY_USER" | "UPDATED_AFTER_VERIFICATION" | "UPDATED_BY_SUPPORT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Location_userAccount$data = {
  readonly locationDetails: {
    readonly source: UserAccountLocationSource;
    readonly updatedAt: ContraAPIScalars.DateTime;
  } | null;
  readonly " $fragmentType": "Location_userAccount";
};
export type Location_userAccount$key = {
  readonly " $data"?: Location_userAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"Location_userAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Location_userAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LocationDetails",
      "kind": "LinkedField",
      "name": "locationDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "source",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserAccount",
  "abstractKey": null
};

(node as any).hash = "71b21be30149d0651e4556df694d5874";

export default node;
